import { IDP_ROLES, IdpSession } from './provider';

/**
 * O portao do sem-vinculo: autenticado nao e autorizado.
 *
 * O auto-registro do IDP esta ligado e o Keycloak federa o Google, entao
 * qualquer pessoa cria uma identidade e volta do login com um token
 * criptograficamente perfeito. Identidade nao e vinculo: sem esta checagem,
 * quem nunca foi cliente do Sapron ganha sessao no Sapron.
 */

const BUSINESS_ROLES = new Set<string>(IDP_ROLES);

/**
 * Tem vinculo quem satisfaz pelo menos um: `sapronUserId` presente, ou pelo
 * menos uma role da taxonomia de negocio.
 *
 * A role e comparada contra a taxonomia e nunca contada: o Keycloak pode
 * devolver na claim `roles` as built-in que todo usuario carrega
 * (`default-roles-seazone`, `offline_access`, `uma_authorization`), e ai
 * `roles.length > 0` deixaria entrar qualquer conta recem-registrada.
 *
 * `sapronUserId` e comparado com `undefined`, nunca por falsidade: `0` e id
 * valido na base legada e `!sapronUserId` negaria acesso a ele.
 */
export function temVinculo(session: IdpSession): boolean {
  return session.sapronUserId === undefined
    ? session.roles.some((role) => BUSINESS_ROLES.has(role))
    : true;
}
